import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class ManagerLoginListItem extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap() {
        this.props.Callback(this.props.User);
    }

    render() {
        return (
            <div className="listdiv">
                <button className="listItem" onClick={evt => this.handleTouchTap(false)}>
                    <label className="listItemLabelTop">{this.props.User.UserName}</label>
                    <Ink />
                </button>
            </div>
        )
    }
}

ManagerLoginListItem.propTypes = {
    User: PropTypes.object.isRequired,
    Callback: PropTypes.func
}
function mapStateToProps() {
    return {

    }
}

export default connect(mapStateToProps, {  })(ManagerLoginListItem)


// WEBPACK FOOTER //
// src/components/ManagerLoginListItem.jsx